import { Box, Hidden } from "@mui/material";
import React from "react";
import NewHeroSection from "./NewHeroSection";
import MobileHeroSection from "./MobileHeroSection";

const MainHome = () => {
  return (
    <Box>
      <Hidden mdDown>
        <NewHeroSection />
      </Hidden>

      <Hidden mdUp>
        <MobileHeroSection />
      </Hidden>
    </Box>
  );
};

export default MainHome;
